import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxUnchecked = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 15,
		height: 15,
		rx: 1.5,
		stroke: "#B0BEC5"
	})]
});
const ForwardRef = forwardRef(SvgCheckboxUnchecked);
export { ForwardRef as ReactComponent };
